const SIZE = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1280px',
  laptopXL: '1440px',
  desktop: '1920px',
  desktopL: '2560px',
};

type ExtremumType = 'max' | 'min';

export const getDeviceSize = (extremum: ExtremumType) => ({
  mobileS: `${extremum}-width: ${SIZE.mobileS}`,
  mobileM: `${extremum}-width: ${SIZE.mobileM}`,
  mobileL: `${extremum}-width: ${SIZE.mobileL}`,
  tablet: `${extremum}-width: ${SIZE.tablet}`,
  laptop: `${extremum}-width: ${SIZE.laptop}`,
  laptopL: `${extremum}-width: ${SIZE.laptopL}`,
  laptopXL: `${extremum}-width: ${SIZE.laptopXL}`,
  desktop: `${extremum}-width: ${SIZE.desktop}`,
  desktopL: `${extremum}-width: ${SIZE.desktopL}`,
});
